import $ from 'jquery'

export default {
    name: 'antecedent-adulte-personnel',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_physio: true,

            save_loading: false,

            atcd_allergo_p: {
                v_model: {
                    'pev_a_jour': '', 'hors_pev': '', 'hors_pev_justif': '',
                    'prophylaxie_anti_paustre': '',
                    'regime_bien_conduit': '', 'regime_justif': '', 'deparasitage': '', 'contage_tuberculeux': '', 
                    'fumeur': '', 'acoolique': '', 
                    'patho_hospitalisation': '', 'patho_hospi_nombre': '', 'patho_hospi_date': '', 
                    'patho_transfusion': '', 'patho_transfusion_nombre': '', 'patho_transfusion_date': '', 
                    'patho_drepanocytose': '', 'patho_allergie_medicamenteuse': '', 'patho_allergie_med_mention': '',
                    'patho_autre_allergies': '', 'patho_autre_allergie_mention': '', 'patho_atopie': '', 'patho_atopie_mention': '', 
                    'patho_asthme': '', 'patho_asthme_mention': '', 'patho_hemolyse': '', 'patho_hemolyse_mention': '', 
                    'patho_chirurgicaux': '', 'patho_chirurgicaux_mention': ''
                }
            },

            fields: {
                'pev_a_jour': '', 'hors_pev': '', 'hors_pev_justif': '',
                'prophylaxie_anti_paustre': '',
                'regime_bien_conduit': '', 'regime_justif': '', 'deparasitage': '', 'contage_tuberculeux': '', 
                'fumeur': '', 'acoolique': '', 
                'patho_hospitalisation': '', 'patho_hospi_nombre': '', 'patho_hospi_date': '', 
                'patho_transfusion': '', 'patho_transfusion_nombre': '', 'patho_transfusion_date': '', 
                'patho_drepanocytose': '', 'patho_allergie_medicamenteuse': '', 'patho_allergie_med_mention': '',
                'patho_autre_allergies': '', 'patho_autre_allergie_mention': '', 'patho_atopie': '', 'patho_atopie_mention': '', 
                'patho_asthme': '', 'patho_asthme_mention': '', 'patho_hemolyse': '', 'patho_hemolyse_mention': '', 
                'patho_chirurgicaux': '', 'patho_chirurgicaux_mention': ''
            }
        }
    },
    computed: {
        antecedent_adulte_personnel() {
            return this.$store.getters["antecedent_adulte_personnel"];
        },
    },
    mounted() {
        this.listeChampATCDAdultePersonnel()
    },
    methods: {
        initFields() {
            const fld_keys = Object.keys(this.fields);
            fld_keys.forEach((key) => {
                this.atcd_allergo_p.v_model[key] = this.antecedent_adulte_personnel[key]

                this.is_loading = false
                
            });
        },

        async listeChampATCDAdultePersonnel() {
            this.is_loading = true
            
            let filter_data = {
                patient_id: this.consultation.patient_id,
                data_type: 'antecedent_adulte_personnel',
                est_en_cours: true
            }

            this.$store.dispatch('getPatientAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        toggleSection() {
            this.is_physio = (this.is_physio)?false:true
        },

        async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        async onlyDigitSlash(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,/]+/g, ''))
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                patient_id: parseInt(this.consultation.patient_id),
                data_type: 'antecedent_adulte_personnel',
                antecedents: this.atcd_allergo_p.v_model,
                atcd_persistent: 1      //  0 si l'antécédent doit se vider lorsqu'on termine la consultation
            }

            this.$store.dispatch('savePatientAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDAdultePersonnel()
                }

                this.save_loading = false
            })
        }
    }
}


